'use strict';

var index = require('../../../_virtual/index.js_commonjs-exports5.js');
var index$2 = require('../../array.prototype.flat/index.js');
var index$1 = require('../../global-cache/index.js');
require('./utils/constants.js');
require('./utils/getClassName.js');
require('./utils/separateStyles.js');
var getClassName = require('../../../_virtual/getClassName.js_commonjs-exports.js');
var separateStyles = require('../../../_virtual/separateStyles.js_commonjs-exports.js');
var constants = require('../../../_virtual/constants.js_commonjs-exports3.js');

(function (exports) {
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _arrayPrototype = index$2;

var _arrayPrototype2 = _interopRequireDefault(_arrayPrototype);

var _globalCache = index$1;

var _globalCache2 = _interopRequireDefault(_globalCache);

var _constants = constants.__exports;

var _getClassName = getClassName.__exports;

var _getClassName2 = _interopRequireDefault(_getClassName);

var _separateStyles2 = separateStyles.__exports;

var _separateStyles3 = _interopRequireDefault(_separateStyles2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Function required as part of the react-with-styles interface. Parses the styles provided by
 * react-with-styles to produce class names based on the style name and optionally the namespace if
 * available.
 *
 * stylesObject {Object} The styles object passed to withStyles.
 *
 * Return an object mapping style names to class names.
 */
function create(stylesObject) {
  var stylesToClasses = {};
  var styleNames = Object.keys(stylesObject);
  var sharedState = _globalCache2['default'].get(_constants.GLOBAL_CACHE_KEY) || {};
  var _sharedState$namespac = sharedState.namespace,
      namespace = _sharedState$namespac === undefined ? '' : _sharedState$namespac;

  styleNames.forEach(function (styleName) {
    var className = (0, _getClassName2['default'])(namespace, styleName);
    stylesToClasses[styleName] = className;
  });
  return stylesToClasses;
}

/**
 * Process styles to be consumed by a component.
 *
 * stylesArray {Array} Array of the following: values returned by create, plain JavaScript objects
 * representing inline styles, or arrays thereof.
 *
 * Return an object with optional className and style properties to be spread on a component.
 */
function resolve(stylesArray) {
  var flattenedStyles = (0, _arrayPrototype2['default'])(stylesArray, Infinity);

  var _separateStyles = (0, _separateStyles3['default'])(flattenedStyles),
      classNames = _separateStyles.classNames,
      hasInlineStyles = _separateStyles.hasInlineStyles,
      inlineStyles = _separateStyles.inlineStyles;

  var specificClassNames = classNames.map(function (name, index) {
    return String(name) + ' ' + String(name) + '_' + String(index + 1);
  });
  var className = specificClassNames.join(' ');

  var result = { className: className };
  if (hasInlineStyles) result.style = inlineStyles;
  return result;
}

exports['default'] = { create: create, resolve: resolve };
}(index.__exports));
